import isIpad from '@/utils/isIpad';
import isFullscreenDisabled from '@/utils/isFullscreenDisabled';

export interface AttentionState {
    /** A task route is shown: attention is only tracked there. */
    active: boolean;
    /** The window lost focus or the page is hidden. */
    distracted: boolean;
    fullscreen: boolean;
}

/**
 * Same rule as the user-attention modal of `App.vue`: distracted, or out of fullscreen when fullscreen
 * is required — it is not on iPad (#825) nor when disabled for local tests (#850).
 */
export default function isAttentionLost({ active, distracted, fullscreen }: AttentionState): boolean {
    if (!active) return false;

    return distracted || (!isIpad() && !isFullscreenDisabled() && !fullscreen);
}
